export default __webpack_public_path__ + "static/media/unlockStats@2x.b1514be4.png";